import { render, staticRenderFns } from "./Corporations.vue?vue&type=template&id=0b7a9d2a"
import script from "./Corporations.vue?vue&type=script&lang=js"
export * from "./Corporations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports